import { render, staticRenderFns } from "./MappingList.vue?vue&type=template&id=03bd0716&"
import script from "./MappingList.vue?vue&type=script&lang=js&"
export * from "./MappingList.vue?vue&type=script&lang=js&"
import style0 from "./MappingList.vue?vue&type=style&index=0&id=03bd0716&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports